module.exports = __webpack_public_path__ + "static/media/passo6.ab0a8349.jpg";